import React from 'react';
import { cn } from '../../utils';
import { BRAND_COLORS } from '../layout/app-sidebar/constants';

interface AppTopbarUserProps {
  className?: string;
}

export function AppTopbarUser({ className }: AppTopbarUserProps) {
  return (
    <div className={cn('tw-flex tw-items-center', className)}>
      {/* The avatar alone, as the 2026 rebrand mockups draw it: a 38px
          prussian circle with lucide's `User` glyph. The name is in the menu
          it opens. */}
      <div
        className="tw-rounded-full tw-flex tw-items-center tw-justify-center"
        style={{
          backgroundColor: BRAND_COLORS.PRUSSIAN,
          color: '#ffffff',
          width: '38px',
          height: '38px',
          minWidth: '38px',
          minHeight: '38px',
        }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
          style={{ width: '28px', height: '28px', display: 'block' }}
        >
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
    </div>
  );
}
